import type { ReactElement } from 'react';

interface GroupPropertiesPanelProps {
  readonly onDelete: () => void;
}

/** 불러온 문서의 그룹 노드 — 핸들·속성 없이 삭제만 된다(스펙 §2-3·§6-3). */
export const GroupPropertiesPanel = ({ onDelete }: GroupPropertiesPanelProps): ReactElement => (
  <div className="flex flex-col gap-3">
    <p className="text-xs leading-relaxed text-muted-foreground">
      불러온 디자인의 그룹은 옮기거나 크기를 바꿀 수 없고 삭제만 할 수 있습니다.
    </p>
    <button
      type="button"
      className="self-start text-xs text-muted-foreground underline-offset-4 hover:text-destructive hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      onClick={onDelete}
    >
      삭제
    </button>
  </div>
);
